
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.11 13.34l-2.54-2.54 2.63-2.62A5.05 5.05 0 0018 8a4.07 4.07 0 00-4 4 4.8 4.8 0 00.17 1.14l-5.64 5.8A1.72 1.72 0 008 20.16a1.76 1.76 0 001.75 1.75 2 2 0 001.25-.44l.09-.08 5.6-5.6a3.64 3.64 0 001.31.26 4.08 4.08 0 004-4 6.65 6.65 0 00-.18-1.31l-2.71 2.6z"}})])
          )
        }
      }
    